import React from "react";
import { Translate } from "react-localize-redux";

class CeeReportDateInformation extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div style={{ display: "flex", flexDirection: "column", fontSize: "0.8em", textAlign: "right", margin: "1em" }}>
                    <span>
                        <Translate id="Search.Cee.DateRequested" />
                            :&nbsp;
                        <span style={{ fontWeight: "600" }}>
                            {this.props.inserted}
                        </span>
                    </span>
                    <span>
                        <Translate id="Search.Cee.DateProcessed" />
                            :&nbsp;
                        <span style={{ fontWeight: "600" }}>
                            {this.props.completed}
                        </span>
                    </span>
                    {this.props.obligation &&
                        <span>
                            <Translate id="Search.Cee.MonetaryObligationProcessed" />
                                :&nbsp;
                            <span style={{ fontWeight: "600" }}>
                                {this.props.obligation}
                            </span>
                        </span>
                    }
                </div>
            </React.Fragment>
        )
    }
}

export default CeeReportDateInformation;